import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import * as Mlt from '_mlt';
import { useLanguage } from './../state';
export function getMltText(props, lang) {
    let mlt;
    if (typeof props === 'string' || props === null || props === undefined) {
        mlt = props;
    }
    else if ('text' in props) {
        mlt = props.text;
    }
    else if ('id' in props) {
        mlt = Mlt.getName(props.id);
    }
    else {
        mlt = props;
    }
    return LocalText(mlt, lang);
}
export function LocalText(text, locale) {
    if (!text) {
        return undefined;
    }
    if (typeof text === 'string') {
        return text;
    }
    if (locale === 'cs' && text.cs) {
        return text.cs;
    }
    if (locale === 'en' && text.en) {
        return text.en;
    }
    return text.en || text.cs || text.default || undefined;
}
export function MLT(props) {
    const lang = useLanguage();
    const text = getMltText(props, lang);
    return _jsx(_Fragment, { children: text || null });
}
export function BooleanText(props) {
    if (props.value) {
        return _jsx(MLT, { cs: "Ano", en: "Yes" });
    }
    else {
        return _jsx(MLT, { cs: "Ne", en: "No" });
    }
}
